import React from "react";

import Hail from "./Hail";

const Fire = (props) => <Hail {...props} event="fire" />;

export default Fire;
